import React from "react";
import GradientText from "@/components/GradiantTitle";
import ButtonComponent from "@components/ButtonComponent";
import Loader from "@components/LoaderComponent/loader";

/**
 * BusinessDayHeader component - Header section with title and skip button
 * @param {string} title - Header title
 * @param {boolean} isLoading - Loading state
 * @param {function} onSkipClick - Callback for skip button
 * @param {function} translate - i18n translate function
 */
const BusinessDayHeader = ({ title, isLoading, onSkipClick, translate }) => {
  return (
    <div className="flex justify-between items-center">
      <GradientText>{title}</GradientText>
      {isLoading ? (
        <div className="p-4 min-w-[155px]">
          <Loader />
        </div>
      ) : (
        <ButtonComponent
          id="skip-day"
          color="blue"
          onClick={onSkipClick}
          ref={null}
          icon={null}
          text={translate("business-day.actions.skip")}
          width="max"
        />
      )}
    </div>
  );
};

export default BusinessDayHeader;
